"use strict";
/**
 * @file Created on 20.06.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var WindowItemSimulationConverter_1 = require("../../../window/conversions/WindowItemSimulationConverter");

var NSimulationProductDTO_1 = require("../model/NSimulationProductDTO");

var NSimulationProductDTOConverter_1 = require("./NSimulationProductDTOConverter");
/**
 * @author Tomas Leity
 */


var NSimulationProductDTOConverterImpl =
/*#__PURE__*/
function (_NSimulationProductDT) {
  _inherits(NSimulationProductDTOConverterImpl, _NSimulationProductDT);

  /**
   * @param windowItemSimConverter
   */
  function NSimulationProductDTOConverterImpl(windowItemSimConverter) {
    var _this;

    _classCallCheck(this, NSimulationProductDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NSimulationProductDTOConverterImpl).call(this));
    _this.windowItemSimConverter = windowItemSimConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(NSimulationProductDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new NSimulationProductDTO_1.NSimulationProductDTO(NSimulationProductDTO_1.NSimulationProductDTO.schema.productId.valueOf(conversions.toClassReferenceId(source.productId)), NSimulationProductDTO_1.NSimulationProductDTO.schema.productName.valueOf(source.productName), NSimulationProductDTO_1.NSimulationProductDTO.schema.productExternalId.valueOf(source.productExternalId), NSimulationProductDTO_1.NSimulationProductDTO.schema.simulation.valueOf(conversions.asObject(source, 'simulation', function (obj) {
        return _this2.windowItemSimConverter.toObject(obj, conversions);
      })));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        productId: conversions.toDocumentReferenceId(source.productId),
        productName: source.productName,
        productExternalId: source.productExternalId,
        simulation: conversions.asObject(source, 'simulation', function (obj) {
          return _this3.windowItemSimConverter.toDocument(obj, conversions);
        })
      });
      return result;
    }
  }]);

  return NSimulationProductDTOConverterImpl;
}(NSimulationProductDTOConverter_1.NSimulationProductDTOConverter);
/**
 * IOC Container qualifier
 */


NSimulationProductDTOConverterImpl.QUALIFIER = {
  documentType: NSimulationProductDTO_1.NSimulationProductDTO.name
};
NSimulationProductDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [WindowItemSimulationConverter_1.WindowItemSimulationConverter])], NSimulationProductDTOConverterImpl);
exports.NSimulationProductDTOConverterImpl = NSimulationProductDTOConverterImpl;